import { render, staticRenderFns } from "./SsoAccess.vue?vue&type=template&id=49a5af52&scoped=true&"
import script from "./SsoAccess.vue?vue&type=script&lang=js&"
export * from "./SsoAccess.vue?vue&type=script&lang=js&"
import style0 from "./SsoAccess.vue?vue&type=style&index=0&id=49a5af52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5af52",
  null
  
)

export default component.exports